/**
 * Money formatting, in the currency the drop reports in.
 *
 * Lives in the data layer rather than the field's `util.ts` because the agent quotes the same
 * figures as the widgets and must label them the same way: the reporting currency is served
 * (`currency.reporting` / `site.ntsCurrency`) and is not always GBP. `field/util.ts` re-exports
 * these, so the field's imports are unchanged.
 */

const SYMBOLS: Record<string, string> = { GBP: "£", EUR: "€", USD: "$" };

/** Currency symbol for an ISO code; unknown codes keep their code, never a wrong symbol. */
export function curSym(code = "GBP"): string {
  return SYMBOLS[code] ?? code + " ";
}

export function fmtMoneyShort(value: number, code?: string): string {
  const c = curSym(code);
  const v = Math.round(value);
  if (v >= 1e6) {
    return c + (v / 1e6).toFixed(1) + "m";
  }
  return v >= 1e3 ? c + Math.round(v / 1e3) + "k" : c + v;
}

/**
 * The whole-site money read, in millions. Real per-SKU values are three or four figures, so
 * anything under a million degrades to `fmtMoneyShort` rather than rendering "£0.0m".
 */
export function moneyM(v: number, code?: string): string {
  return v >= 1e6 ? curSym(code) + (v / 1e6).toFixed(1) + "m" : fmtMoneyShort(v, code);
}
